import { render, staticRenderFns } from "./WithIncidentAnswerBySelectButton.vue?vue&type=template&id=1fa0ad94&scoped=true"
import script from "./WithIncidentAnswerBySelectButton.ts?vue&type=script&lang=ts&external"
export * from "./WithIncidentAnswerBySelectButton.ts?vue&type=script&lang=ts&external"
import style0 from "./WithIncidentAnswerBySelectButton.scss?vue&type=style&index=0&id=1fa0ad94&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa0ad94",
  null
  
)

export default component.exports